/**
 * Common tasks used in the branch and leaf categories.
 * @namespace
 */
const categoryCommon = {
	/**
	 * Handles all the setup for categoryCommon tasks. Should be called when the document is ready.
	 * @returns {undefined}
	 */
	init: function() {
		// Register the event tracking first.
		this.eventTracking();

		$('#ManufacturerCategoriesContainer').insertAfter('#categoryLeafTableContent');

		$('.ManufacturerCategories').insertAfter('#ManufacturerCategoriesContainer');

		this.buyingGuideController();

		this.popularBrandsViewMore();

		this.speakerLocationController();
	},
	/**
	 * Target page element on click
	 * @returns {undefined}
	 */
	buyingGuideController: function () {
		$("a.onPageElement").click(function (e) {
			let anchorHref = $(this).attr("href");

			if ($(anchorHref).length > 0) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $(anchorHref).offset().top
				}, 500);
			}
		});
	},
	/**
	 * Category branch and leaf page event tracking.
	 * @returns {undefined}
	 */
	eventTracking: function() {
		$(document.body).on('click', '.other-spkr-loc-btn', function() {
			let categoryIdentifier = $('.categoryIdentifier').val().replaceAll('"', '-inch'),
				selectedVehicleStrInput = $('#selectedVehicleStr'),
				selectedVehicleStr = (selectedVehicleStrInput.length > 0 ? selectedVehicleStrInput.attr('name').replaceAll('"', '-inch') : ''),
				spkrLocBtnEventLabel = $(this).data('spkrLocLabel').replaceAll('"', '-inch') + ' - ' + selectedVehicleStr;

			ga('send', 'event', categoryIdentifier, 'Location Filter', spkrLocBtnEventLabel);
		});

		$(document.body).on('click', '.popularLinksSection .iconOuterContainer a', function() {
			let categoryIdentifier = $('.categoryIdentifier').val().replaceAll('"', '-inch'),
				popularLinksEventLabel = $(this).data('label').replaceAll('"', '-inch');

			ga('send', 'event', categoryIdentifier, 'Popular Link', popularLinksEventLabel);
		});

		$(document.body).on('click', 'a.fitmentTrackEventStr', function() {
			let vehicleSelectorLeafEventLabel = $(this).data('eventLabel').replaceAll('"', '-inch');

			ga('send', 'event', 'Fitment', 'Leaf Set Vehicle', vehicleSelectorLeafEventLabel);
		});
	},
	/**
	 * Handles hiding and showing the overflow of popular brands.
	 * @returns {undefined}
	 */
	popularBrandsViewMore: function() {
		$('#category-popular-brands').each(function() {
			let $this = $(this),
				divCount = $this.find('.innerContainer').length,
				x = 8,
				remainingCount = divCount - 8;

			if (divCount <= x) {
				$this.find('.viewMore').hide();
			}
			$this.find('.innerContainer:lt(' + x + ')').show();

			$this.find('.viewMore').click(function() {
				x = ((x + 4) <= divCount) ? x + remainingCount : divCount;
				$this.find('.innerContainer:lt('+x+')').show();
				if (x == divCount){
					$this.find('.viewMore').hide();
					$this.find('.hideAll').show();
				}
			});

			$this.find('.hideAll').click(function() {
				if (divCount > 8) {
					// elements from backward
					let hideCount = 8 - divCount;

					$this.find('.innerContainer').slice(hideCount).hide();
					$this.find('.viewMore').show();
					$this.find('.hideAll').hide();
				}
			});
		});
	},
	/**
	 * Handles hidding list of vehicle specs when long.
	 * @returns {undefined}
	 */
	speakerLocationController: function() {
		if ($('.shop-by-location ul li').length > 3) {
			$('.shop-by-location .showMoreSpecs').on('click',function(e) {
				e.preventDefault();
				let $this = $(this),
					shopByLocation = $this.closest('.shop-by-location'),
					specCount = $this.data('specCount');

				shopByLocation.toggleClass('open');
				if (shopByLocation.hasClass('open')) {
					$this.html('... see less');
				} else {
					$this.html('... show ' + specCount + ' more locations');
				}
			});
		}
	}
};

export default categoryCommon;
